import { render, staticRenderFns } from "./homeHeader.vue?vue&type=template&id=39c9bac2&"
import script from "./homeHeader.vue?vue&type=script&lang=js&"
export * from "./homeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/menu/college/homeHeader.vue"
export default component.exports